export const GET_PUBLICATIONS = "GET_PUBLICATIONS"
export const GET_PUBLICATIONS_SUCCESS = "GET_PUBLICATIONS_SUCCESS"
export const GET_PUBLICATIONS_FAIL = "GET_PUBLICATIONS_FAIL"

export const ADD_PUBLICATION = "ADD_PUBLICATION"
export const ADD_PUBLICATION_SUCCESS = "ADD_PUBLICATION_SUCCESS"
export const ADD_PUBLICATION_FAIL = "ADD_PUBLICATION_FAIL"

export const UPDATE_PUBLICATION = "UPDATE_PUBLICATION"
export const UPDATE_PUBLICATION_SUCCESS = "UPDATE_PUBLICATION_SUCCESS"
export const UPDATE_PUBLICATION_FAIL = "UPDATE_PUBLICATION_FAIL"

export const DELETE_PUBLICATION = "DELETE_PUBLICATION"
export const DELETE_PUBLICATION_SUCCESS = "DELETE_PUBLICATION_SUCCESS"
export const DELETE_PUBLICATION_FAIL = "DELETE_PUBLICATION_FAIL"

export const SET_PUBLICATION_FIELD_ERRORS = "SET_PUBLICATION_FIELD_ERRORS"
